import styled from "styled-components";

export const StyledWrapperAgenda = styled.div`
  margin-top: 40px;
  padding: 0px;
  h1 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
    margin-left: 70px;
    color: #000000;
  }
  hr {
    height: 6px;
    opacity: 1.25;
    background: #E63457;
  }
  .nav-tabs .nav-link {
    color: #000000;
  }
  ul {
    columns: 2;
    li {
      &:nth-child(7) {
        -webkit-column-break-after: always;
        break-after: always;
      }
    }
    @media (max-width: 768px) {
      columns: auto;
      padding-left: 0px;
    }
    @media (max-width: 767px) {
      columns: 2;
    }
    @media (max-width: 425px) {
      columns: auto;
      paddin
    }
  }
  
`;
